'use client'

import { cn } from '@/lib/utils'
import { usePathname } from 'next/navigation'
import type { ComponentPropsWithoutRef } from 'react'

export const Table = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'table'>) => {
  const pathname = usePathname()
  const fullscreenPages = ['/models/leaderboard', '/voice-models/leaderboard']
  const isFullscreen = fullscreenPages.includes(pathname)

  return (
    <div
      className={cn(
        'overflow-x-auto scrollbar-hidden',
        !isFullscreen && 'md:-mx-20 lg:-mx-20'
      )}
    >
      <table
        {...props}
        className={cn(
          'w-full min-w-max border-collapse',
          'text-sm [&_tr:hover]:bg-secondary/50',
          isFullscreen
            ? '[&_tr]:border-b [&_tr:last-child]:border-0 [&_tr]:border-border/50'
            : '[&_td]:border-t [&_td]:border-border/50',
          '[&_th]:p-3 [&_th]:font-regular',
          isFullscreen && '[&_th]:border-b [&_th]:border-border/50',
          '[&_td]:p-3',
          isFullscreen && '[&_td]:border-b [&_td]:border-border/50',
          '[&_td]:break-words [&_td]:min-w-[20px] [&_td]:max-w-[min(400px,40vw)]',
          '[&_th]:break-words [&_th]:min-w-[20px] [&_th]:max-w-[min(400px,40vw)]',
          '[&_thead]:sticky [&_thead]:top-0 [&_thead]:bg-background [&_thead]:z-10',
          className
        )}
      />
    </div>
  )
}

export default Table
